import { useRouter } from "next/dist/client/router";
import { createContext, useState, useEffect } from "react";
import { loadProject } from "../lib/loaders/loadProject";
import Project from "../lib/models/Project";

//CTX's
export const ProjectCtx = ({ staticProjet, staticNextProject }) => {
  const [projet, setProjet] = useState(
    staticProjet ? new Project(staticProjet) : {}
  );
  const [nextProject, setNextProject] = useState(
    staticNextProject ? new Project(staticNextProject) : {}
  );
  const router = useRouter();

  useEffect(() => {
    const getData = async () => {
      const { project: projetFromAPi, nextProject: nextProjectAPI } =
        await loadProject(router.query.id);
      /*  if (typeof projetFromAPi?.attributes == "undefined")
        return router.push("/"); */
      setProjet(new Project(projetFromAPi));
      setNextProject(new Project(nextProjectAPI));
    };
    getData();
  }, [router.query.id]);

  return {
    projet,
    nextProject,
  };
};
export const ProjectContext = createContext({});
